import { routerReducer } from 'react-router-redux'

import auth from './auth'
import consultants from './consultants'
import search from './search'
import userInfo from './userInfo'
import suggestions from './suggestions'
import messages from './messages'
import rooms from './rooms'
import settings from './settings'

export default (state = {}, action) => ({
  auth: auth(state.auth, action),
  consultants: consultants(state.consultants, action),
  search: search(state.search, action),
  router: routerReducer,
  userInfo: userInfo(state.userInfo, action),
  suggestions: suggestions(state.suggestions, action),
  messages: messages(state.messages, action),
  rooms: rooms(state.rooms, action),
  settings: settings(state.settings, action),
})



// WEBPACK FOOTER //
// ./src/reducers/index.js